export default "__VITE_ASSET__DRUVFmL9__"